var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"border-t-1 border-secondary flex flex-wrap justify-center items-center"},[_c('div',[_vm._v("Diese Webseite verwendet Cookies. ")]),_c('input-button',{staticClass:"m-4",on:{"click":_vm.consent}},[_vm._v(" Einverstanden ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }